import { PartnerScope } from './partner-client.model';

/**
 * Guided-connect partner state for the integration cards (REV-21656):
 * one entry per guided partner app, with this org's connection state.
 * Mirrors the partner-connections DTO of aumico-be.
 */
export interface IPartnerConnection {
    clientId: string;
    displayName: string;
    appKey: string | null;
    startUrl: string | null;
    scopes: PartnerScope[];
    connected: boolean;
    consented: boolean;
}
